import * as React from 'react';
import { ClassName } from '../../utils/utils';

interface IDropdownProps {
  children: any;
  type?: string;
  isOpened?: boolean;
  dropFrom?: string;
}

class Dropdown extends React.Component<IDropdownProps> {

  public render() {
    const { children, type, dropFrom } = this.props;

    return (
      <React.Fragment>
        <div
          className={ClassName('dropdown', [type, dropFrom]) + (this.props.isOpened ? ' isOpened' : '')}
        >
          <div className="dropdown__content">
            {children}
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Dropdown;



// WEBPACK FOOTER //
// ./src/modules/Dropdown/Dropdown.tsx